<template>
  <div class="submit">
    <button @click="$emit('submit')" class="uk-button uk-button-primary" type="button" :disabled="!isValid">{{text}}</button>
    <small class="valid-message" v-show="!isValid">Заполните обязательные поля</small>
  </div>
</template>

<script>
export default {
  props: {
    isValid: {
      default: true
    },
    text: {
      default: 'Принять'
    }
  }
}
</script>

<style lang="scss" scoped>
.submit {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.valid-message {
  margin-top: 5px;
  color: rgb(255, 151, 144);
}
</style>